import { baseEnvironment } from "./base-environment";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const environment = {
  ...baseEnvironment,
  development: true,
  uat: false,
  staging: false,
  production: false,
  useAppCheckDebugToken: false,
  firebase: {
    apiKey: "AIzaSyBdvpTYq_dyl9aOI13Q5RsA2yBuCCRADAo",
    authDomain: "nexus-dev-e366c.firebaseapp.com",
    projectId: "nexus-dev-e366c",
    storageBucket: "nexus-dev-e366c.firebasestorage.app",
    messagingSenderId: "206717992086",
    appId: "1:206717992086:web:2aaab4792348881b9596b7",
    measurementId: "G-ECQJYGQ6Q8",
    appCheck: {
      reCaptchaV3SiteKey: "6Lcze4IrAAAAACUB99ePJtDeWSH8qbBfAxUFxP7Y"
    }
  }
};